import { TenderFormField } from '@modules/tender-platform/constants/content';

export const validateTenderLotMinPrice = (value: string, getFieldValue: (name: TenderFormField) => string) => {
  if (!value || Number(getFieldValue(TenderFormField.StartPrice)) >= Number(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('Минимальная цена должна быть меньше, чем стартовая!'));
};
